/**
 * Whether **Refresh data** is allowed: current filter fingerprint must match the last successful write.
 */
export function isTraceRefreshDataAllowed(
    lastSuccessfulFetchFingerprint: string | null,
    currentFingerprint: string | null
): boolean {
    return (
        lastSuccessfulFetchFingerprint !== null &&
        currentFingerprint !== null &&
        currentFingerprint === lastSuccessfulFetchFingerprint
    );
}
